module.exports = __webpack_public_path__ + "static/media/crocodile(20).0da43ce6.PNG";